import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export default client;
